import { render, staticRenderFns } from "./RoleAddUser.vue?vue&type=template&id=377dcc52"
import script from "./RoleAddUser.vue?vue&type=script&lang=js"
export * from "./RoleAddUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports